
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.971 4.471L8.03 3.53 5.167 6.39V0H3.833v6.39L.971 3.53.03 4.47 4.5 8.943 8.971 4.47z","fill":"#7E8186"}})])
          )
        }
      }
    